module.exports = __webpack_public_path__ + "static/img/addService2.78d13a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceExperience/addService2.png
// module id = ZCP2
// module chunks = 1